'use strict'

const { fields } = require('cloud-utils/config/device-settings/default-v2.json')
const {
  fields: privacySettingsConfig
} = require('cloud-utils/config/device-privacy-mode-config/privacy-mode-settings.json')
angular
  .module('surfsightApp.controllers')
  .controller('BulkDeviceUiSettingsEditController', [
    '$scope',
    '$mdDialog',
    'dataFromCaller',
    function ($scope, $mdDialog, dataFromCaller) {
      $scope.selectedBulkDevices = dataFromCaller.selectedDevices
      $scope.device_setting_selected_tab = 0
      $scope.uiSettings = {
        ...fields.reduce(
          (
            uiConfig,
            {
              name,
              defaultValue,
              defaultLockedStatus,
              valueFieldName,
              configure
            }
          ) => ({
            ...uiConfig,
            [name]: {
              [valueFieldName || 'value']: defaultValue,
              locked: defaultLockedStatus,
              allowInBulk: configure.allowInBulk
            }
          }),
          {}
        )
      }
      $scope.privacySettings = privacySettingsConfig.reduce((result, field) => {
        result[field.name] = field.defaultValue
        return result
      }, {})
      $scope.privacyMode = {
        value: null
      }
      $scope.prevPrivacySettings = angular.copy($scope.privacySettings)
      $scope.confirmUpdateUiSettings = () => {
        $mdDialog.hide($scope.uiSettings)
      }
      $scope.cancel = () => {
        $mdDialog.cancel()
      }
      $scope.showPrivacyModeForm = () => {
        $scope.device_setting_selected_tab = 1
      }
      $scope.goBackToDeviceSettings = () => {
        $scope.device_setting_selected_tab = 0
      }
      $scope.confirmBulkPrivacyModeUpdate = async () => {
        // updated privacy settings
        $mdDialog.hide({
          type: 'privacy_settings_changed',
          privacyMode: $scope.privacyMode.value,
          privacySettings: $scope.privacySettings
        })
      }
    }
  ])
